import { List, Record } from "immutable";

export type SectionId = string;
type CourseId = string;
type ContentId = string;
type ModuleId = string;

export type SectionType = {
  id?: SectionId;
  parentId: (SectionId | CourseId) | null | undefined;
  title?: string;
  number?: number;
  description?: string;
  sectionIds: List<SectionId>;
  contentIds: List<ContentId>;
  exerciseContentIds: List<ContentId>;
  moduleIds: List<ModuleId>;
  examQuestionsCount?: number;
  hasSequentialContent?: boolean;
};

export type OptionalSectionType = Partial<SectionType>;

const defaultSection: SectionType = {
  id: undefined,
  parentId: undefined,
  title: undefined,
  description: undefined,
  number: undefined,
  sectionIds: List(),
  contentIds: List(),
  exerciseContentIds: List(),
  moduleIds: List(),
  examQuestionsCount: undefined,
  hasSequentialContent: undefined
};

export default class Section extends Record(defaultSection) {}
